<h1>
  <span i18n="@@office-setting.terms-and-conditions-for"
    >Terms and Conditions for</span
  >
  {{ this.activeOfficeName }}
</h1>
<form
  id="office-terms-and-conditions-form"
  class="office-settings-form"
  [formGroup]="officeTermsAndConditionsForm"
>
  <article id="terms-and-conditions-controls">
    <div class="d-flex flex-column">
      <label
        for="terms-and-conditions-name"
        class="mb-0"
        i18n="@@office-setting.select-terms-and-conditions"
      >
        Select T&C
      </label>
      <mat-form-field appearance="outline" id="terms-and-conditions-name">
        @if (!isEditing) {
          <mat-select
            panelClass="office-settings-panel"
            [value]="selectedTermsAndConditions?.name"
            (valueChange)="onSelectTermsAndConditions($event)"
            [disabled]="isEditing"
          >
            @for (
              termsAndConditions of activeOfficeTermsAndConditions;
              track termsAndConditions
            ) {
              <mat-option
                [value]="termsAndConditions.name"
                class="office-settings-select-option"
              >
                {{ termsAndConditions.name }}
              </mat-option>
            }
          </mat-select>
        }
        @if (isEditing) {
          <input
            type="text"
            class="input-field"
            aria-label="Name of T&C"
            matInput
            placeholder="Name of T&C"
            formControlName="name"
          />
        }
        @if (controlHasError("name", "required")) {
          <mat-error> Terms & Conditions name is required </mat-error>
        }
        @if (controlHasError("name", "maxlength")) {
          <mat-error>
            Terms & Conditions name must have at most 30 characters.
          </mat-error>
        }
      </mat-form-field>
    </div>

    @if (!iAmAdmin) {
      <div>
        <em
          [ngbPopover]="popContent"
          container="body"
          triggers="mouseenter:mouseleave"
          class="fa fa-exclamation-circle ps-2 text-danger"
        ></em>
        <ng-template
          #popContent
          i18n="@@settings.text-only-office-admin-can-edit"
        >
          Only an Office Admin can edit this section.
        </ng-template>
      </div>
    }

    @if (iAmAdmin) {
      <div
        id="selected-terms-and-conditions-actions"
        class="d-flex flex-column align-items-center"
      >
        <p class="mb-0">Action</p>
        <div class="d-flex">
          <button
            [disabled]="this.selectedTermsAndConditions === undefined"
            class="office-settings-icon-button"
            mat-icon-button
            color="primary"
            aria-label="Edit terms and conditions"
            (click)="startEditing()"
          >
            <mat-icon>edit</mat-icon>
          </button>
          <button
            [disabled]="
              this.selectedTermsAndConditions === undefined && !this.isEditing
            "
            class="office-settings-icon-button"
            mat-icon-button
            color="primary"
            aria-label="Delete terms and conditions"
            (click)="deleteOfficeTerms()"
          >
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>
    }

    <mat-checkbox formControlName="isDefault" class="align-self-center">
      <p
        style="margin-bottom: 0"
        i18n="@@office-setting.default-terms-and-conditions"
      >
        Default T&C
      </p>
    </mat-checkbox>
    <!-- separate because mouseenter does not get fired if checkbox is disabled -->
    <em
      class="fa fa-exclamation-circle align-self-center"
      style="font-size: 16px; margin-left: -8px; margin-bottom: 2px"
      [ngbPopover]="defaultTncTooltip"
      placement="right auto"
      triggers="mouseenter:mouseleave"
      popoverClass="office-settings-tooltip"
    >
    </em>
  </article>
  @if (iAmAdmin) {
    <button
      [disabled]="isEditing"
      color="secondary"
      mat-flat-button
      class="office-settings-action-button"
      (click)="createTermsDraft()"
    >
      <mat-icon>add_circle</mat-icon>
      <span i18n="@@office-setting.add-terms-and-conditions">ADD T&C</span>
    </button>
  }
  <article id="terms-and-conditions-body-container">
    <mat-form-field appearance="outline" class="w-100">
      <textarea
        rows="10"
        matNativeControl
        formControlName="body"
        [placeholder]="
          iAmAdmin
            ? '(Type your terms and condition here)'
            : 'Terms and Conditions'
        "
      ></textarea>
    </mat-form-field>
  </article>
  @if (isEditing) {
    <button
      [disabled]="!officeTermsAndConditionsForm.valid"
      color="secondary"
      mat-flat-button
      class="office-settings-action-button save-changes me-3"
      (click)="saveChanges()"
      i18n="@@office-setting.save-changes"
    >
      Save Changes
    </button>
  }
  @if (isEditing) {
    <button
      color="secondary"
      mat-flat-button
      class="office-settings-action-button discard-changes"
      (click)="discardChanges()"
      i18n="@@office-setting.discard-changes"
    >
      Discard Changes
    </button>
  }
</form>

<ng-template #defaultTncTooltip>
  <p i18n="@@office-setting.default-terms-and-conditions-tooltip" class="m-0">
    T&C which will be displayed by default when creating a quotation for a
    shipper.
  </p>
</ng-template>
